import { useEffect, useState } from "react";
import { formatIndianCurrency } from "../../utils/utils";

const PayLater = ({ totalAmt, fiftyPercentAmount, onSelectionChange }) => {
  const fullAmount = Number(totalAmt) || 0;
  const partialPercent = Number(fiftyPercentAmount);

  // Only show component if a valid partial percent exists (not 100%)
  const showPartialOption =
    partialPercent && !isNaN(partialPercent) && partialPercent !== 100;

  // Always default to 100%
  const [selectedPercent, setSelectedPercent] = useState(100);

  const calculatePayNow = (percent) => (fullAmount * percent) / 100;
  const payNowAmount = calculatePayNow(selectedPercent);
  const payLaterAmount = fullAmount - payNowAmount;

  useEffect(() => {
    if (selectedPercent !== null) {
      onSelectionChange?.({
        selectedPercent,
        payNow: payNowAmount,
        payLater: payLaterAmount,
      });
    }
  }, [selectedPercent, fullAmount]);

  // If no partial payment option is available, and 100% is selected, don't render the component
  if (!showPartialOption) return null;

  const handleChange = (e) => {
    setSelectedPercent(Number(e.target.value));
  };

  return (
    <div className="checkbox_styles">
      {/* Partial Payment Option */}
      <div
        className={`paynow_option ${
          selectedPercent === partialPercent ? "selected" : ""
        }`}
      >
        <div className="tool_tip_container">
          <label htmlFor={`paynow_${partialPercent}`} className="paynow_input">
            <input
              type="radio"
              name="percent"
              id={`paynow_${partialPercent}`}
              value={partialPercent}
              checked={selectedPercent === partialPercent}
              onChange={handleChange}
            />
            Pay {partialPercent}% Now, Balance Pay Later
          </label>
          {selectedPercent === partialPercent && (
            <div className="tool_tip">
              <b>Note:</b> The remaining balance will be due 15 days before your
              departure date. <br /> Please ensure timely payment to avoid any
              inconvenience.
            </div>
          )}
        </div>
        <div className="paynow_amount_main">
          <div className="flex justify_content_between pt_10">
            <span>Pay Now</span>
            <span className="price_text">
              {formatIndianCurrency(calculatePayNow(partialPercent).toFixed(2))}
            </span>
          </div>
          <div className="flex justify_content_between">
            <span>Pay Later</span>
            <span>
              <strong>
                {formatIndianCurrency(
                  (fullAmount - calculatePayNow(partialPercent)).toFixed(2)
                )}
              </strong>
            </span>
          </div>
        </div>
      </div>

      <div className="dashed_border">
        <div></div>
        <span>or</span>
        <div></div>
      </div>

      {/* Full Payment Option */}
      <div
        className={`paynow_option ${selectedPercent === 100 ? "selected" : ""}`}
      >
        <label htmlFor="paynow_100" className="paynow_input">
          <input
            type="radio"
            name="percent"
            id="paynow_100"
            value={100}
            checked={selectedPercent === 100}
            onChange={handleChange}
          />
          Pay 100% Now
        </label>
        <div className="paynow_amount_main">
          <div className="flex justify_content_between pt_10">
            <span>Pay Now</span>
            <span className="price_text">
              {formatIndianCurrency(fullAmount.toFixed(2))}
            </span>
          </div>
          <div className="flex justify_content_between">
            <span>Pay Later</span>
            <span>
              <strong>{formatIndianCurrency("0.00")}</strong>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayLater;
